import { useOutletContext } from 'react-router-dom'

import { EmployeesListEmployeesPageDocument } from 'generated/resources/graphql'
import { useDocumentTitle } from 'usehooks-ts'

import Loading from 'modules/core/components/Loading'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useQuery } from 'modules/core/hooks/useQuery'
import { useClientSideFeatureFlag } from 'modules/core/lib/clientSideFeatureFlags'
import i18n from 'modules/core/lib/i18n'

import EmployeesList from 'modules/employees/components/EmployeesList'
import type { RouteContextParams } from 'modules/employees/lib/RouteContextParams'

import EmployeeCollectionPage from './EmployeeCollectionPage'

// TODO: Replace this EmployeeListPage with the EmployeeCollectionPage
// once the new data collection feature is fully released to all clients
const EmployeesListPage = () => {
  const { filtersForm } = useOutletContext<RouteContextParams>()
  const { isFeatureFlagEnabled } = useClientSideFeatureFlag()
  const { company } = useCurrentSession()
  const { data, loading } = useQuery(EmployeesListEmployeesPageDocument, {
    variables: {
      companyId: company.id,
      featureNames: ['dev_employees_data_collection'],
    },
  })

  useDocumentTitle(i18n.t('employees.title'), {
    preserveTitleOnUnmount: false,
  })

  const hasEmployeesDataCollectionFeature =
    data?.features.featuresConnection.nodes.find(
      (feature) => feature.name === 'dev_employees_data_collection'
    )?.enabled ?? false

  if (loading) {
    return <Loading />
  }

  if (isFeatureFlagEnabled('employee-data-collection') || hasEmployeesDataCollectionFeature) {
    return <EmployeeCollectionPage />
  }

  return <EmployeesList filtersForm={filtersForm} />
}

export default EmployeesListPage
